var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableLockout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#ED9C96",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.1208C14.5252 16.1208 14.9509 15.6951 14.9509 15.17C14.9509 14.6449 14.5252 14.2192 14 14.2192C13.4749 14.2192 13.0492 14.6449 13.0492 15.17C13.0492 15.6951 13.4749 16.1208 14 16.1208Z",
    fill: "#ED9C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7125 11.5067H11.2875C11.2409 11.5067 11.2 11.5067 11.1534 11.5067V10.83C11.1534 9.12085 11.6375 7.98335 14 7.98335C16.5259 7.98335 16.8467 9.21419 16.8467 10.2875C16.8467 10.515 17.0275 10.6959 17.255 10.6959C17.4825 10.6959 17.6634 10.515 17.6634 10.2875C17.6634 8.21669 16.4325 7.16669 14 7.16669C10.7159 7.16669 10.3367 9.25502 10.3367 10.83V11.5592C8.70335 11.7634 8.16669 12.5917 8.16669 14.6275V15.7125C8.16669 18.1042 8.89585 18.8334 11.2875 18.8334H16.7125C19.1042 18.8334 19.8334 18.1042 19.8334 15.7125V14.6275C19.8334 12.2359 19.1042 11.5067 16.7125 11.5067ZM14 16.9317C13.0259 16.9317 12.2384 16.1384 12.2384 15.17C12.2384 14.1959 13.0317 13.4084 14 13.4084C14.9684 13.4084 15.7617 14.2017 15.7617 15.17C15.7617 16.1442 14.9742 16.9317 14 16.9317Z",
    fill: "#ED9C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableLockout);
export default __webpack_public_path__ + "static/media/AvailableLockout.3461b1d590b1e4c9a2870c5e7a6d3476.svg";
export { ForwardRef as ReactComponent };